export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-02.jpg'),
        title: '业务流程',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '每个运作良好的公司的主体 ',
      description: `<p style="font-size:1.05rem">
      您的业务流程是您组织目标的基础。流畅，高效，高度组织业务流程是实现目标的关键。您的所有业务活动对良好的运营至关重要贵公司和所有公司都基于相同的蓝图：业务流程。从这个意义上讲，一个组织良好，简化的业务流程就是这样每个运作良好的公司的骨干。​​我们拥有广泛而丰富的经验，可用于分析您当前的业务流程，优化您的工作流程，消除任何低效率并改善业务流程的每个步骤。简化业务流程是我们的核心之一目标和我们的业务规划方法的一部分。在MaesInfo,我们将拥有丰富的经验和能力用于帮助我们的客户提高工作效率和降低运营成本。</p>`
    },
    {
      title: '​​MaesInfo将带来持久的利益到你的公司:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-02.jpg')+`)"></span>
      <span>研究和分析您的业务流程和系统实现。提出建议，以优化和改善这些过程和做法提高效率（例如，发现并消除业务中的瓶颈）过程，资源的低效使用，发现和消除不必要的流程，减少导致部分流程的错误数量重做，改善沟通）编制详细报告，突出显示需要改进的所有领域，以及协助优化您的业务流程。</span>`
    }
  ]
}
